import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'San Diego',
    description: 'San Diego keeps your time, expenses, and tasks on-brand, on message, and on time. Effortless living made possible.',
    url: 'https://sandiego.app'
}